import { Injectable, Injector } from '@angular/core';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';
import { IActivityOperationDto } from '../shared/model/alc/activity-operation.dto';

@InjectableByKey({ key: 'ActivityOperationService' })
@Injectable({ providedIn: 'root' })
export class ActivityOperationService extends GridODataService<IActivityOperationDto> {
  constructor(injector: Injector) {
    super(injector, '/api/alc/activity/operation');
  }

  protected mapResponse(
    response: PagedResultDto<IActivityOperationDto>
  ): PagedResultDto<IActivityOperationDto> {
    return response;
  }
}
